module.exports = "query infopagePaths {\n  entries(section: [\"infopages\"], limit: 1) {\n    id\n    slug\n    uri\n  }\n}"